if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"workspace_mgmt","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 854 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}